<template>
    <b-col cols=12>
        <b-row>
            <b-col cols=12>
                <h5 class="mb-0 pb-3 pt-5 text-center txt-color-secondary">Locked Funds</h5>
            </b-col>
            <b-col cols=12>
                <b-card no-body class='p-2 pt-2' style="">
                    <b-container>
                        <b-row class='box'>
                            <b-col cols=2  class='p-0' style='display: flex;'>
                                <div class='icon'>
                                    <div class='wraper'>
                                        <SmartGlobalIcon
                                            v-bind="{width: 25,height: 25,fill: '#212529'}"
                                        />
                                    </div>
                                </div>
                            </b-col>
                            <b-col cols=10 class="text-right color-primary">
                                <h1 class="locked mb-0">{{ this.GLOBAL.formatter(this.GLOBAL._toDecimal(this.amount, 9), 2)}} SGBT</h1>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-card>
            </b-col>
        </b-row>
    </b-col>
</template>
<script>
import SmartGlobalIcon from '@/components/icons/SmartGlobalIcon'
export default {
  components: {
    SmartGlobalIcon
  },
  props: [
    'amount'
  ],
  data () { return {} }
}
</script>

<style scoped>
    /*.color-primary {
        color: #F4C96C;
    }*/
    @media screen and (max-width: 576px) {
        .locked {
            padding-top: 0.25rem;
            font-size: 1.5rem;
        }
    }
/*
    .box .icon{
        background-color: #F4C96C !important;
    }
    .box .icon{
        display: table;
        height: 37px;
        width: 37px;
        margin: auto;
        border-radius: 25px;
    }
    .box .icon .wraper{
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }
*/
</style>
